import { AlertsAppNirvanaDataProvider } from '../dataProvider/AlertsAppNirvanaDataProvider';
import { BaseWebComponentDataProviderFactory } from '../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_NIRVANA } from '../../webcomponents.constants';

export class AlertsAppDataProviderFactory extends BaseWebComponentDataProviderFactory {
  constructor() {
    super();
    this.map.set(API_TYPE_NIRVANA, AlertsAppNirvanaDataProvider);
  }
}
